<template>
  <div class="invitacion-container">
    <div class="invitacion-card">

      <!-- 👑 CORONA SUPERIOR (.PNG ORIGINAL) -->
      <img src="@/assets/CORON.png" class="corona-sello" alt="Corona" ref="coronaRef" />

      <p ref="titulo" class="titulo-principal">
        TENEMOS EL HONOR DE INVITARTE<br>
        A LA CELEBRACIÓN DE MIS
      </p>

      <h1 ref="nombres" class="subtitulo">
        XV AÑOS
      </h1>

<p ref="fecha" class="fecha"><span class="great-value">A</span>zael</p>
      <div class="seccion-idiomas" ref="idiomaSeccion">
        <div class="opciones-idioma">
          <button @click="seleccionar('es')" class="btn-idioma">
            <!-- 📨 Icono de sobre/invitación -->
            <svg class="icono-sobre" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
            </svg>
            <span>Ingresar</span>
            <span class="sheen"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import gsap from 'gsap';

export default {
  name: 'InvitacionIdioma',
  emits: ['idioma-seleccionado'],
  setup(_, { emit }) {
    const coronaRef = ref(null);
    const titulo = ref(null);
    const nombres = ref(null);
    const fecha = ref(null);
    const idiomaSeccion = ref(null);

    const seleccionar = (idioma) => {
      emit('idioma-seleccionado', idioma);
    };

    onMounted(() => {
      // Animación de entrada escalonada estilo lujo
      gsap.timeline({ delay: 0.3 })
        .from(coronaRef.value, {
          opacity: 0,
          scale: 0.5,
          y: -30,
          duration: 1.2,
          ease: 'back.out(1.7)',
        })
        .from(titulo.value, {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.6')
        .from(nombres.value, {
          opacity: 0,
          scale: 0.9,
          y: 30,
          duration: 1.2,
          ease: 'power3.out',
        }, '-=0.5')
        .from(fecha.value, {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.8')
        .from(idiomaSeccion.value, {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.8');
    });

    return {
      seleccionar,
      coronaRef,
      titulo,
      nombres,
      fecha,
      idiomaSeccion,
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700&family=Great+Vibes&family=Playfair+Display:ital,wght@0,500;0,600;0,700;1,400;1,500&family=Montserrat:wght@400;500;600;700&display=swap');

/* CONTENEDOR PRINCIPAL - MISMO FONDO Y TEXTURA */
.invitacion-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  padding: 1rem;
  margin: 0;
  box-sizing: border-box;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  position: relative;
  overflow: hidden;
  background-color: #d8e9f3;
/* Capa oscura (0.4 de opacidad) + Imagen */
  background-image: 
    linear-gradient(rgba(0, 0, 0, 0.733), rgba(0, 0, 0, 0.605)), 
    url('@/assets/B3D70B5E-2599-498C-923E-4B6C6082F8F9.png');  
  position: relative;
  overflow: hidden;
}

.invitacion-card {
  position: relative;
  padding: 40px 24px;
  margin: 0 auto;
  border-radius: 18px;
  background-color: transparent;
  text-align: center;
  width: 100%;
  max-width: 420px;
  z-index: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 👑 CORONA IMAGEN .PNG */
.corona-sello {
  width: 195px;
  height: auto;
  margin: 0 auto 20px auto;
  display: block;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.15));
}

/* TEXTO SUPERIOR */
.titulo-principal {
  font-family: 'Cinzel', 'Playfair Display', serif;
  font-size: 0.95rem;
  color: #4979a0;
  margin-bottom: 1rem;
  letter-spacing: 2px;
  line-height: 1.6;
  font-weight: 600;
  text-transform: uppercase;
}

/* TÍTULO PRINCIPAL "XV AÑOS" EN AZUL CELESTE */
.subtitulo {
  font-family: 'Cinzel', 'Playfair Display', serif;
  font-size: 2.8rem !important;
  margin: 0 0 0.5rem 0;
  font-weight: 700;
  letter-spacing: 4px;
  text-align: center;
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
  text-transform: uppercase;
  color: #4979a0;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

/* NOMBRE PRINCIPAL EN CURSIVA DORADA */
.fecha {
  font-family: 'Great Vibes', cursive, serif;
  font-size: 3rem !important;
  color: #cba56b;
  margin-bottom: 2rem;
  letter-spacing: 1px;
  font-weight: 500;
  opacity: 0.95;
}

.seccion-idiomas {
  margin: 1rem 0 0;
  width: 100%;
}

.opciones-idioma {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* 🔘 BOTÓN INGRESAR CELESTE Y BORDE DORADO */
.btn-idioma {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  padding: 14px 28px;
  border-radius: 25px;

  background: linear-gradient(135deg, #ffffff 0%, #f0f7fc 100%);
  color: #4979a0;
  text-decoration: none;

  font-family: 'Playfair Display', serif;
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 2px;
  text-transform: uppercase;
  line-height: 1;

  border: 1.5px solid #cba56b;

  box-shadow:
    0 4px 12px rgba(73, 121, 160, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);

  overflow: hidden;
  cursor: pointer;
  width: 100%;
  max-width: 240px;
  margin: 0 auto;

  transition: all 0.35s ease;
}

.btn-idioma:hover {
  transform: translateY(-2px) scale(1.02);
  background: #ffffff;
  box-shadow:
    0 6px 18px rgba(73, 121, 160, 0.25),
    0 0 12px rgba(203, 165, 107, 0.3);
}

/* 📨 Icono del sobre en color celeste */
.icono-sobre {
  width: 18px;
  height: 18px;
  fill: #4979a0;
  position: relative;
  z-index: 2;
}

/* EFECTO BRILLO DORADO SOBRE EL BOTÓN */
.btn-idioma::before {
  content: "";
  position: absolute;
  top: 0;
  left: -120%;
  width: 70%;
  height: 100%;
  background: linear-gradient(
    120deg,
    transparent,
    rgba(203, 165, 107, 0.25),
    transparent
  );
  transform: skewX(-22deg);
  animation: brilloDorado 3.5s infinite;
  z-index: 1;
}

@keyframes brilloDorado {
  0% { left: -120%; }
  100% { left: 180%; }
}

.btn-idioma span {
  position: relative;
  z-index: 2;
}

@media (max-width: 480px) {
  .invitacion-card {
    padding: 2rem 1rem;
  }
  .corona-sello {
    width: 160px;
  }
  .titulo-principal {
    font-size: 0.85rem;
  }
  .subtitulo {
    font-size: 2.3rem !important;
  }

}

.great-value {
  font-family: 'Great Vibes', cursive;
}
</style>